import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import HeaderPublicLayout from "./HeaderPublicLayout/HeaderPublicLayout";
import FooterPublicLayout from "./FooterPublicLayout/FooterPublicLayout";
import BookingSection from "./../../helpers/BookingSection/BookingSection";
import { scrollAnimation } from "./../../utils";

const PublicLayout = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollAnimation();
    window.addEventListener("scroll", scrollAnimation);
  }, []);

  const isHideHeader = ["/", "/menu"].includes(pathname);

  return (
    <div className="bg">
      {!isHideHeader && <HeaderPublicLayout />}

      <div className={isHideHeader ? "" : "wrapper"}>{children}</div>
      <BookingSection />
      <FooterPublicLayout />
    </div>
  );
};

export default PublicLayout;
